import { type FileUploadResponseItem } from '@atlassian/conversation-assistant-service-api/types/assistance-service';
import {
	type CommandConstructor,
	type CommandProperties,
	type SerializableValue,
} from '@atlassian/rovo-content-bridge-api/command';
import { createCommand } from '@atlassian/rovo-content-bridge-api/command-creator';

/**
 * Properties for the rovo inline input box send message command.
 *
 * @extends CommandProperties
 */
export interface InlineInputBoxSendMessageCommandProperties extends CommandProperties {
	prompt: string;
	source: string;
	productKey: string;
	deepResearchEnabled: boolean;
	webSearchEnabled: boolean;
	appFilters?: {
		source: string;
		friendlyName: string;
		iconUrl: string;
	}[];
	files?: FileUploadResponseItem[];
	contentId: string | number | undefined;
	agentId?: string;
}

/**
 * A command sent by the rovo inline input box client to send a message to rovo chat.
 *
 * @summary {@link CommandProperties.senderId} is requesting {@link CommandProperties.receiverId} to send a message to the input prompt box.
 */
export const InlineInputBoxSendMessageCommand: CommandConstructor<
	InlineInputBoxSendMessageCommandProperties,
	SerializableValue
> = createCommand<InlineInputBoxSendMessageCommandProperties>(
	'inline-input-box-send-message-command',
);
